/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import TimeSeriesPlotFigure from '@/components/charts/TimeSeriesPlotFigure';
import type { ParsedTimeSeriesCsv } from '@/lib/timeSeries/parseTimeSeriesCsv';
import type {
    TimeSeriesLegendNames,
    TimeSeriesPlotType,
    TimeSeriesTraceColors,
} from '@/lib/timeSeries/timeSeriesPlotly';
import type { StoredPlotlyResponse } from '@/types/eeCheck';

interface StaticTimeSeriesPlotProps {
    chartType?: TimeSeriesPlotType;
    figure?: StoredPlotlyResponse | null;
    fillParent?: boolean;
    legendNames?: TimeSeriesLegendNames;
    parsedTimeSeries?: ParsedTimeSeriesCsv | null;
    right?: string[];
    title?: string;
    traceColors?: TimeSeriesTraceColors;
    xAxisTitle?: string;
    yAxisTitle?: string;
}

function StaticTimeSeriesPlot(props: StaticTimeSeriesPlotProps) {
    return <TimeSeriesPlotFigure {...props} />;
}

export default StaticTimeSeriesPlot;
